'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { luckyDrawBunja } from '@flipster/features/src/contentful/lucky-draw/state';
import { TokenCard } from '@flipster/features/src/contentful/lucky-draw/token-card';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

import { RegisterButton } from '@web/app/[locale]/(web)/campaign/_section/misc/campaign-button';

export const TokenOverview = () => {
  const { luckyDrawsLayout, luckyDrawsAtom, luckyDrawSlugs, isRegisteredAtom, registerMutationAtom } =
    useBunja(luckyDrawBunja);
  const luckyDraws = useAtomValue(luckyDrawsAtom);
  const isFinished = luckyDraws?.every((draw) => draw?.luckyDrawEventStatus === 'FINISHED');
  const isRegistered = useAtomValue(isRegisteredAtom);
  const registerMutation = useAtomValue(registerMutationAtom);

  if (!luckyDrawsLayout) return null;
  return (
    <div className={css({ pb: { base: 64, tablet: 80 }, whiteSpace: 'pre-line' })}>
      <RegisterButton
        isRegistered={isRegistered}
        isFinished={isFinished}
        handleRegister={() => registerMutation.mutateAsync()}
      />
      <h2
        className={css({
          textStyle: 'Display/XL',
          color: 'content.default.level-5',
          mt: { base: 64, tablet: 80 },
        })}
      >
        {luckyDrawsLayout[0]?.tokenTitle}
      </h2>
      <p
        className={css({
          textStyle: 'Title/S',
          color: 'content.default.level-3',
          mt: { base: 12, tablet: 16 },
        })}
      >
        {luckyDrawsLayout[0]?.tokenDescription}
      </p>
      <ul
        className={flex({
          flexDirection: { base: 'column', tablet: 'row' },
          gap: { base: 16, tablet: 56 },
          justify: 'center',
          mt: 40,
        })}
      >
        {luckyDrawSlugs?.map((slug, index) => (
          <TokenCard
            index={index}
            key={slug}
            handleRegister={registerMutation.mutateAsync}
            css={{ bg: 'linear-gradient(#262A51, #606797)' }}
          />
        ))}
      </ul>
    </div>
  );
};
